import { render, staticRenderFns } from "./HighlightMenuSection.vue?vue&type=template&id=f639826a&scoped=true&"
import script from "./HighlightMenuSection.vue?vue&type=script&lang=js&"
export * from "./HighlightMenuSection.vue?vue&type=script&lang=js&"
import style0 from "./HighlightMenuSection.vue?vue&type=style&index=0&id=f639826a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f639826a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
